// @ts-strict-ignore
import type { SerializedStyles } from "@emotion/serialize";
import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Spacer } from "@aviary";
import { l } from "@shared/locales/i18n";
import { useSearchParams } from "@shared/react-router-dom/react-router-dom";
import type { PatientAdditionalAttributesType } from "@shared/types/PatientAdditionalAttributesType";
import type { PractitionerAdditionalAttributesType } from "@shared/types/PractitionerAdditionalAttributesType";
import type { SignInAdditionalAttributesType } from "@shared/types/SignInAdditionalAttributesType";

import { AppleSSOButton } from "./AppleSSOButton/AppleSSOButton";
import { GoogleSSOButton } from "./GoogleSSOButton/GoogleSSOButton";

import * as styles from "./LoginOptions.styles";

interface Props {
  commonSSOProps?: SSOButtonProps;
  hideOrText?: boolean;
  isStorefronts?: boolean;
}

interface SSOButtonProps {
  treatmentPlanSlug?: string;
  labRecommendationId?: string;
  storeSlug?: string;
  pracTypeId?: string;
  signUpPage?: string;
  pageVersion?: string;
  disabled?: boolean;
  additionalAttributes?: SignInAdditionalAttributesType &
    PractitionerAdditionalAttributesType &
    PatientAdditionalAttributesType;
  uuid?: string;
  buttonStyles?: SerializedStyles;
}

const LoginOptions = ({ commonSSOProps, hideOrText, isStorefronts }: Props) => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const isIntake = searchParams.get("intake") === "true";
  const requestedPractitionerId = searchParams.get("requestedPractitionerId");

  if (isStorefronts) {
    return (
      <>
        <div css={styles.rowWrapper}>
          <GoogleSSOButton
            {...commonSSOProps}
            buttonStyles={styles.fullWidthButton}
            isIntake={isIntake}
            requestedPractitionerId={requestedPractitionerId}
          />
          <AppleSSOButton
            {...commonSSOProps}
            buttonStyles={styles.fullWidthButton}
            isOrTextRendered={false}
            isIntake={isIntake}
            requestedPractitionerId={requestedPractitionerId}
          />
        </div>
        <div css={styles.orSection}>
          <Typography variant="footnote" as="span" isMarginless>
            {t(l.appleSSO.Or)}
          </Typography>
        </div>
      </>
    );
  }

  return (
    <>
      <GoogleSSOButton
        {...commonSSOProps}
        isIntake={isIntake}
        requestedPractitionerId={requestedPractitionerId}
      />
      <Spacer height="one" />
      <AppleSSOButton
        {...commonSSOProps}
        isOrTextRendered={!hideOrText}
        isIntake={isIntake}
        requestedPractitionerId={requestedPractitionerId}
      />
    </>
  );
};

export { LoginOptions };
